export default __webpack_public_path__ + "static/media/7R.d9082455.png";